import io from 'socket.io-client'
import store from '@/store/index'
import router from '@/router/index'

export function getPushSocketInstance () {
  let socket = store.getters.getSocketInstance
  if (!socket || socket.id === 0) {
    console.debug('socket created')
    const connectOption = {
      path: '/socket',
      withCredentials: true,
      transports: ['websocket', 'polling'],
      query: { restaurantIdx: store.getters.getStoreIdx }
    }
    socket = io(process.env.VUE_APP_SOCKET_SERVER, connectOption)
    store.commit('setSocketInstance', socket)
    socket.prependAny((eventName, ...args) => {
      console.debug('prependAny---', eventName, args)
    })
    socket.on('error', (error) => {
      // Fired upon a connection error.
      console.error('error---', error)
    })
    socket.on('reconnect', (attempt) => {
      // Fired upon a successful reconnection.
      console.debug('reconnect---', attempt)
    })
    socket.on('reconnect_attempt', (attempt) => {
      // Fired upon an attempt to reconnect.
      console.debug('reconnect_attempt---', attempt)
    })
    socket.on('reconnect_error', (error) => {
      // Fired upon a reconnection attempt error.
      console.error('reconnect_attempt---', error)
    })
    socket.on('reconnect_failed', () => {
      // Fired when couldn't reconnect within reconnectionAttempts.
      console.warn('reconnect_attempt')
    })
    socket.on('ping', () => {
      // Fired when a ping packet is received from the server.
      console.debug('ping')
    })
    socket.on('connect', () => {
      // Fired upon connection to the Namespace (including a successful reconnection).
      console.debug('connect')
      store.commit('setIsSocketDisconnected', false)
    })
    socket.on('disconnect', (reason) => {
      // Fired upon disconnection. The list of possible disconnection reasons:
      console.debug('disconnected---', reason)
      store.commit('setIsSocketDisconnected', true)
    })
    socket.on('connect_error', (error) => {
      // Fired when a namespace middleware error occurs.
      console.error('connect_error---', error)
    })
    socket.on('info', (res) => {
      console.debug('socket info---', res)
    })
    socket.on('joinSuccess', (data) => {
      console.debug('joinSuccess---', data)
    })
    socket.on('message', ({ data }) => {
      console.debug('socket message---', data)
      const route = router.app.$route
      const storeIdx = store.getters.getStoreIdx
      switch (data.type) {
        case 'waiting':
          if (route.name === 'home') {
            store.dispatch('setWaitingCount', storeIdx)
          } else {
            store.commit('waitingCountChange', true)
          }
          break
        case 'reload':
          store.commit('mutationByKeyValue', [{ key: 'isMaintenanced', value: false }])
          router.push('/')
          window.location.reload()
          break
        case 'line-temp-key':
          store.commit('mutationByKeyValue', [{ key: 'receivedLineTempKey', value: data.tempKey }])
          break
        case 'info':
        case 'scope-message':
        case 'restaurant-status-waiting':
          if (data.action === 'logout' && data.title === '매장 상태가 변경되었습니다.') {
            store.commit('setAccessToken', '')
            store.commit('setRefreshToken', '')
            router.app.$router.push('/login')
          } else {
            store.dispatch('setWaitingCount', storeIdx)
            store.dispatch('setRestaurant', storeIdx)
          }
          break
        default :
          if (route.name === 'home') {
            store.dispatch('setRestaurant', storeIdx)
          } else {
            store.commit('setChangeFlag', data.type)
          }
      }
    })
  }
  return socket
}
